import { faPhoneVolume as fasPhoneVolume } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class LeadForm extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: (
			<>
				Kérd <strong>részletes eredményeidet email</strong>-ben és várd <strong>szakértőnk hívását</strong>,
				hogy segítsen a felmerülő kérdések tisztázásában!
			</>
		),
	};

	protected renderHeader(): ReactNode {
		const { title } = this.props;

		return (
			<Card.Header>
				<div className="d-flex align-items-center">
					<FontAwesomeIcon icon={fasPhoneVolume} className="text-gold mr-3" size="3x" />
					<div className="h4 mb-0 font-weight-light">{title}</div>
				</div>
			</Card.Header>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
